import { useEffect, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import {
  getApiErrorMessage,
  getAuthErrorMessage,
  loginRequest,
  startSsoLogin,
} from "../services/authService";
import '../../sass/pages/login.scss'

// axios.defaults.headers.common["X-CSRFToken"] = csrfToken;

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { status, refreshSession, ssoEnabled } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const authError = searchParams.get("authError");
    if (authError) {
      setError(getAuthErrorMessage(authError));
    }
  }, [searchParams]);

  if (status === "authenticated") {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    try {
      const session = await loginRequest(email, password);
      if (!session.authenticated) {
        setError("Login failed. Please try again.");
        return;
      }

      await refreshSession();
      navigate("/", { replace: true });
    } catch (requestError) {
      setError(getApiErrorMessage(requestError));
    }
  };


  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Platform API Tester Login</h2>
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input
            type="email"
            id="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error ? <p>{error}</p> : null}
        <button type="submit">Signin - Local User</button>
        {ssoEnabled ? (
          <button type="button" onClick={startSsoLogin}>
            Signin - SSO
          </button>
        ) : null}
      </form>
    </div>
   
  );
};

export default Login;
